var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropdownListIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 7,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#757575",
  strokeMiterlimit: 10,
  d: "m12.005.967-4.234 4.2c-.5.495-1.318.495-1.818 0L1.719.966"
})));
export { SvgDropdownListIcon as ReactComponent };
export default __webpack_public_path__ + "309d6d840c8684493947114eeb694ab3.svg";